module.exports = __webpack_public_path__ + "img/ELLOS.cebe687d.png";